var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"loader"})]),_c('b-row',{staticClass:"pt-4",attrs:{"align-h":"center"}},[_c('p',[_vm._v("Loading...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }